<template>
	<div>
		<div class="row my-4">
			<div class="col-12 col-lg-6">
				<b-form-checkbox
					v-model="needChargePoints"
					switch
					:value="1"
					:unchecked-value="0"
					class="mb-3"
				>
					Использовать баллы лояльности {{ allowedPointsToCharge > 0 && needChargePoints ? `(${allowedPointsToCharge})` : ''}}
				</b-form-checkbox>
				<div
					v-if="allowedPointsToCharge > 0 && needChargePoints"
					class="d-flex align-items-center justify-content-between"
				>
					<b-form-input
						id="loyalty_points_to_charge"
						v-model="pointsToCharge"
						type="range"
						label="Выберите количество баллов для списания"
						step="1"
						min="0"
						:max="allowedPointsToCharge"
					/>
					<span class="points-to-charge ml-4">
						{{ pointsToCharge }}
					</span>
				</div>
			</div>
			<div
				v-if="loyaltyProfile.level"
				class="col-12 col-lg-3 "
			>
				<div
					:style="{
						backgroundColor: cardBackground,
					}"
					class="text-center loyalty-card"
				>
					<div class="loyalty-card-title mb-0">
						{{ loyaltyProfile.level.name }}
					</div>
					<div>уровень</div>
				</div>
			</div>
			<div class="col-12 col-lg-3 text-right">
				Вы можете оплатить баллами до
				{{ Math.round(loyaltyProfile.level.max_payment_percent) }}%
				стоимости
			</div>
		</div>
	</div>
</template>

<script>
import { LOYALTY_LEVELS } from '~/utils/dictionaries';

export default {
	name: 'ChargePoints',
	props: {
		price: {
			type: Number,
			required: true,
		},
		awardedPoints: {
			type: Number,
			default: 0,
		},
		loyaltyProfile: {
			type: Object,
			default: () => ({}),
		},
		cardBackground: {
			type: String,
			default: '',
		},
		selectedProducts: {
			type: Array,
			default: () => ([]),
		},
		allProductsFromGroup: {
			type: Array,
			default: () => ([]),
		},
	},
	data() {
		return {
			levels: LOYALTY_LEVELS,
			allowedPointsToCharge: null,
			needChargePoints: 0,
			pointsToCharge: 0,
			isChargePointsLoading: false,
		};
	},
	computed: {
		user() {
			return this.$auth.user;
		},
		amount() {
			return this.price - this.pointsToCharge;
		},
	},
	watch: {
		needChargePoints: {
			handler(value) {
				this.$emit('input', this.formData());

				if (value) {
					this.getMaxPointsToCharge();
				} else {
					this.pointsToCharge = 0;
				}
			},
			immediate: true,
		},
		pointsToCharge: {
			handler() {
				this.$emit('input', this.formData());
			},
		},
		// price: {
		// 	handler() {
		// 		if (this.needChargePoints) {
		// 			this.getMaxPointsToCharge();

		// 			this.pointsToCharge = 0;
		// 		}
		// 	},
		// },
	},
	async mounted() {
		await this.getLoyaltyLevels();
		await this.getMaxPointsToCharge();
	},
	methods: {
		async getLoyaltyLevels() {
			const {
				data: levels,
				first_program_trigger_threshold: firstProgramThreshold,
			} = await this.$api.getLoyaltyLevels();

			if (firstProgramThreshold) {
				this.firstProgramThreshold = firstProgramThreshold;
			}

			this.levels = levels.map((item) => ({
				...this.levels.find(
					(level) => level.id === item.id,
				),
				...item,
			}));
		},
		async getMaxPointsToCharge() {
			if (!this.$auth.user) {
				return;
			}

			try {
				this.isChargePointsLoading = true;

				this.allowedPointsToCharge = 0;

				const products = this.selectedProducts?.length > 0
					? this.selectedProducts
					: this.allProductsFromGroup;

				// todo Сделать через одну транзакцию со множеством продуктов.
				// Суммирование списываемых баллов, как сейчас, ведет к тому, что если у участника
				// ограниченное количество баллов и на форме несколько разных продуктов, количество
				// доступных для списания баллов на форме умножается на количество разных продуктов и
				// становится совершенно недостоверным. Внизу создал костыль, чтобы этого не было.
				await Promise.all(products.map(async (product) => {
					const chargePoints = Math.abs(
						parseFloat((await this.$api.getTransactionInfoByProgram(
							product.id,
							product.price * (parseFloat(product.quantity ?? 1) || 0),
							true,
						)).points),
					);

					this.allowedPointsToCharge += chargePoints;
				}));

				if (products.length > 1) {
					this.allowedPointsToCharge = Math.min(
						this.allowedPointsToCharge,
						this.loyaltyProfile.points,
					);
				}
			} finally {
				this.isChargePointsLoading = false;
			}
		},
		formData() {
			return {
				needChargePoints: this.needChargePoints,
				pointsToCharge: this.pointsToCharge,
				actualAmount: this.amount,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.points-table {
	border: 1px solid $blue;
	padding: 0.5rem 1rem;
	margin-top: 0.5rem;
	border-radius: 0.7rem;
	max-width: 13rem;
}

.points-to-charge {
	font-size: 1.2rem;
	font-weight: bold;
	color: $blue;
}
</style>
